function DotLoading(): JSX.Element {
  /* Define state / hook */

  /* Custom Data Object for render or other usages */

  /* Render control function / logic */

  /* Data Change Listeners - useEffect/useMemo/useCallback */

  /* Styling */

  /* Render */
  return (
    <div className="row center d-flex mt-3">
      <div className="col-12">
        <div className="spinner-grow text-primary m-2" role="status" />
        <div className="spinner-grow text-secondary m-2" role="status" />
        <div className="spinner-grow text-success m-2" role="status" />
        <div className="spinner-grow text-danger m-2" role="status" />
        <div className="spinner-grow text-warning m-2" role="status" />
      </div>
    </div>
  );
}

export default DotLoading;
